import http from '@/utils/http.js' // 引入封装的request.js文件
import common from '@/config/common.js'


//创建支付二维码
export function createPayCodeUrl(data) {
    return http.request({
        url: common.url + '/papi/pay/createPayCodeUrl',
        method: 'get',
        params: data
    })
}

//检验订单是否支付
export function checkOrderIsPay(data) {
    return http.request({
        url: common.url + '/papi/pay/checkOrderIsPay',
        method: 'get',
        params: data
    })
}

